export default __webpack_public_path__ + "media/images/icons/img-8abc5189168b500267c7c7456ccfa926.png";